import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";

import { useMastersContext } from "../../../../contexts/masters.context";
import categorySecondaryOptionService from "../../../../services/categorySecondaryOptionService";
import CategorySecondaryOptionForm from "./forms/CategorySecondaryOptionForm";

function CategorySecondaryOptionAddEdit() {
  const { id } = useParams();
  let history = useHistory();
  const {
    categorySecondaryOptionState,
    categoryState,
    decoMethodsState,
  } = useMastersContext();

  const [data, setData] = useState({
    Id: -1,
    CategoryID: -1,
    PrimaryDecoID: -1,
    SecondaryDecoID: -1,
  });

  const init = async () => {
    await categoryState.fetch();
    await decoMethodsState.fetch();
    if (id) {
      const result = await categorySecondaryOptionService.getOne(id);
      setData({
        Id: result.csO_ID,
        CategoryID: result.categoryID,
        PrimaryDecoID: result.primaryDecoID,
        SecondaryDecoID: result.secondaryDecoID,
      });
    }
  };

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    setData({
      ...data,
      CategoryID: categoryState.data[0]?.category_ID,
      PrimaryDecoID: decoMethodsState.data[0]?.dM_ID,
      SecondaryDecoID: decoMethodsState.data[0]?.dM_ID,
    });
  }, [categoryState.data, decoMethodsState.data]);

  const saveHandler = async () => {
    // console.log(data);
    // return;

    if (id) {
      const result = await categorySecondaryOptionService.update(data);
      if (result.success === true) {
        categorySecondaryOptionState.fetch();
        history.goBack();
      }
    } else {
      const result = await categorySecondaryOptionService.add(data);
      if (result.success === true) {
        categorySecondaryOptionState.fetch();
        history.goBack();
      }
    }
  };

  return (
    <div>
      <h4>{id ? "Edit" : "New"} Category Secondary Option</h4>
      <hr />
      <div>
        <CategorySecondaryOptionForm
          formData={data}
          setFormData={setData}
          categoryData={categoryState.data}
          decoMethodsData={decoMethodsState.data}
        />
        <hr />
        <div className="d-flex justify-content-center">
          <button
            className="btn btn-sm btn-danger mr-5"
            onClick={(e) => history.goBack()}
          >
            Cancel
          </button>
          <button
            className="btn btn-sm btn-success"
            onClick={(e) => saveHandler()}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export default CategorySecondaryOptionAddEdit;
